"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
/** Utility class for constructing an Eppo API endpoint URL given a provided baseUrl and query parameters */
class ApiEndpoints {
    constructor(params) {
        this.params = params;
        this.params.baseUrl = params.baseUrl ?? constants_1.BASE_URL;
    }
    endpoint(resource) {
        const url = new URL(this.params.baseUrl + resource);
        Object.entries(this.params.queryParams ?? {}).forEach(([key, value]) => url.searchParams.append(key, value));
        return url;
    }
    ufcEndpoint() {
        return this.endpoint(constants_1.UFC_ENDPOINT);
    }
    banditParametersEndpoint() {
        return this.endpoint(constants_1.BANDIT_ENDPOINT);
    }
    precomputedFlagsEndpoint() {
        return this.endpoint(constants_1.PRECOMPUTED_FLAGS_ENDPOINT);
    }
}
exports.default = ApiEndpoints;
//# sourceMappingURL=api-endpoints.js.map